import {
  put, takeLatest, all,
} from 'redux-saga/effects';
import TrackerActions from '@Actions/trackerActions';
import { notification } from 'antd';
import WhatsappIntegrationActions, { whatsappIntegrationActionTypes } from '../../actions/integrations/whatsappIntegrationActions';
import WhatsappIntegrationServices from '../../services/integrations/whatsappIntegrationServices';

/**
 * @param action
 */
function* _getWhatsappConnections(action) {
  try {
    const {
      orgId, callback,
    } = action;
    yield put(WhatsappIntegrationActions.getWhatsappConnectionsLoading(true));
    const linkedWhatsappAccounts = yield WhatsappIntegrationServices.getWhatsappConnections(orgId);
    yield put(WhatsappIntegrationActions.getWhatsappConnectionsSuccess(linkedWhatsappAccounts?.data));
    if (linkedWhatsappAccounts.success) {
      if (callback) {
        callback(linkedWhatsappAccounts.data);
      }
    }
    yield put(WhatsappIntegrationActions.getWhatsappConnectionsLoading(false));
  } catch (error) {
    yield put(WhatsappIntegrationActions.getWhatsappConnectionsLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(whatsappIntegrationActionTypes.GET_WHATSAPP_CONNECTIONS.ERROR, error));
  }
}

/**
 *
 */
function* getWhatsappConnections() {
  yield takeLatest(whatsappIntegrationActionTypes.GET_WHATSAPP_CONNECTIONS.REQUEST, _getWhatsappConnections);
}

/**
 * @param action
 */
function* _toggleWhatsapp(action) {
  try {
    yield put(WhatsappIntegrationActions.toggleWhatsappLoading(true));
    const wp = yield WhatsappIntegrationServices.toggleWhatsapp(action.payload);
    if (wp.success) {
      notification.open({
        type: 'success',
        message: wp.message,
        duration: 4,
        placement: 'top',
      });
      if (action?.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: wp?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(WhatsappIntegrationActions.toggleWhatsappLoading(false));
  } catch (error) {
    yield put(WhatsappIntegrationActions.toggleWhatsappLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(whatsappIntegrationActionTypes.TOGGLE_WHATSAPP.ERROR, error));
  }
}

/**
 *
 */
function* toggleWhatsapp() {
  yield takeLatest(whatsappIntegrationActionTypes.TOGGLE_WHATSAPP.REQUEST, _toggleWhatsapp);
}

/**
 * @param action
 */
function* _updateWhatsappConfiguration(action) {
  try {
    const { payload, callback } = action;
    yield put(WhatsappIntegrationActions.updateWhatsappConfigurationLoading(true));
    const updateWhatsappConfigurationData = yield WhatsappIntegrationServices.updateWhatsappConfiguration(payload);
    if (updateWhatsappConfigurationData.success) {
      notification.open({
        type: 'success',
        message: 'We have successfully updated your whatsapp configurations.',
        duration: 4,
        placement: 'top',
      });
      if (callback) {
        callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: updateWhatsappConfigurationData.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(WhatsappIntegrationActions.updateWhatsappConfigurationLoading(false));
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(WhatsappIntegrationActions.updateWhatsappConfigurationLoading(false));
    yield put(TrackerActions.trackAction(whatsappIntegrationActionTypes.UPDATE_WHATSAPP_CONFIGURATION.ERROR, error));
  }
}

/**
 *
 */
function* updateWhatsappConfiguration() {
  yield takeLatest(whatsappIntegrationActionTypes.UPDATE_WHATSAPP_CONFIGURATION.REQUEST, _updateWhatsappConfiguration);
}

/**
 * @param action
 */
function* _sendWhatsappNotification(action) {
  try {
    yield put(WhatsappIntegrationActions.sendWhatsappNotificationLoading(true));
    const wp = yield WhatsappIntegrationServices.sendWhatsappNotification(action.payload, action.entityName);
    if (wp.success) {
      notification.open({
        type: 'success',
        message: wp.message,
        duration: 4,
        placement: 'top',
      });
      if (action?.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: wp?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(WhatsappIntegrationActions.sendWhatsappNotificationLoading(false));
  } catch (error) {
    yield put(WhatsappIntegrationActions.sendWhatsappNotificationLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(whatsappIntegrationActionTypes.SEND_WHATSAPP_NOTIFICATION.ERROR, error));
  }
}

/**
 *
 */
function* sendWhatsappNotification() {
  yield takeLatest(whatsappIntegrationActionTypes.SEND_WHATSAPP_NOTIFICATION.REQUEST, _sendWhatsappNotification);
}

/**
 *
 */
export default function* whatsappIntegrationSaga() {
  yield all([
    updateWhatsappConfiguration(),
    toggleWhatsapp(),
    getWhatsappConnections(),
    sendWhatsappNotification(),
  ]);
}
